// extracted by mini-css-extract-plugin
export var Hero = "style-module--Hero--Evv0u";
export var Title = "style-module--Title--Twdkw";
export var Subtitle = "style-module--Subtitle--qhIz8";
export var Intro = "style-module--Intro--agHzQ";
export var ImagePrefix = "style-module--ImagePrefix--bcT3l";
export var Image = "style-module--Image--jVafd";